import { DateTimeFormatTypes } from '@/models/common/date-time-format-types.model';
import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { StatisticsListFilter } from '@/models/statistics/statistics-list-filter.model';
import { getDateTimeRangeFormatted } from '@/utils/get-date-time-range.util';
import { formatDatesInPayload } from '@marfa/bo-utils';
import { FormInstance } from 'element-plus';
import { defineStore } from 'pinia';
import { ref } from 'vue';

interface StatisticsListFilterState {
  filterFormDateTimeRange: string[] ;
}

export const statisticsListFilterFormRef = ref<FormInstance>();

export const useStatisticsListFilterStore = defineStore('StatisticsListFilterStore', {
  state: (): StatisticsListFilterState => ({
    filterFormDateTimeRange: getDateTimeRangeFormatted(DateTimeRangeTypes.TODAY, DateTimeFormatTypes.DATE_TIME_FULL),
  }),
  getters: {
    statisticsFilterFormData(state: StatisticsListFilterState): StatisticsListFilter {
      const [fromDate, toDate] = state.filterFormDateTimeRange;

      return formatDatesInPayload({
        payload: { fromDate, toDate },
        isIncludeTime: true,
      }, ['fromDate', 'toDate']);
    },
  },
  actions: {
    setFilterFormData(filterFormDataRange: string []): void {
      this.filterFormDateTimeRange = [...filterFormDataRange];
    },
  },
});
